import shp from "shpjs";
import { readFileAsDataURL } from "../utils";

export const convertShpToGeojson = async (file: File) => {
  const dataUrl = (await readFileAsDataURL(file)) as string;
  const geojson = await shp(dataUrl);

  return geojson;
};
